import type { IconSvgObject } from './types';

const CornerLeftUpIcon: IconSvgObject = [
  ["path", { d: "M14 9.00195L9 4.00195L4 9.00195M9 5.00195L9 17.002C9 18.6588 10.3431 20.002 12 20.002H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CornerLeftUpIcon;
